import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { api } from "../lib/api";

/**
 * Live countdown timer for the $7 summer flash promo window (through Christmas).
 * Reads end_at from /api/promo/dbd (admin-settable).
 * Auto-hides when expired or when admin sets active=false.
 */
const PromoCountdown = ({ compact = false }) => {
    const [promo, setPromo] = useState(null);
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        api.get("/promo/dbd").then((r) => setPromo(r.data)).catch(() => {});
    }, []);

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    if (!promo || !promo.active) return null;
    const end = new Date(promo.end_at).getTime();
    const diff = end - now;
    if (diff <= 0) return null;

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    const Unit = ({ value, label }) => (
        <div className="flex flex-col items-center min-w-[58px]">
            <div className="font-display text-3xl sm:text-4xl text-white tabular-nums tracking-tight">
                {String(value).padStart(2, "0")}
            </div>
            <div className="text-[9px] font-stencil tracking-widest text-red-600 mt-1">{label}</div>
        </div>
    );

    if (compact) {
        return (
            <div
                className="inline-flex items-center gap-2 px-3 py-2 border border-red-700/50 bg-red-900/15"
                data-testid="promo-countdown-compact"
            >
                <Clock size={14} className="text-red-500" />
                <span className="font-stencil text-[10px] tracking-widest text-red-500">
                    ENDS IN {days}d {String(hours).padStart(2, "0")}h {String(minutes).padStart(2, "0")}m
                </span>
            </div>
        );
    }

    return (
        <div
            className="inline-flex flex-col items-center gap-3 border border-red-700/40 bg-gradient-to-b from-red-950/30 to-black p-5"
            data-testid="promo-countdown"
        >
            <div className="flex items-center gap-2 font-stencil text-[10px] tracking-[0.3em] text-red-600">
                <Clock size={12} /> $7 SUMMER PRICE ENDS IN
            </div>
            <div className="flex items-start gap-3 sm:gap-4">
                <Unit value={days} label="DAYS" />
                <div className="font-display text-3xl text-red-700/60 leading-none mt-1">:</div>
                <Unit value={hours} label="HOURS" />
                <div className="font-display text-3xl text-red-700/60 leading-none mt-1">:</div>
                <Unit value={minutes} label="MIN" />
                <div className="font-display text-3xl text-red-700/60 leading-none mt-1">:</div>
                <Unit value={seconds} label="SEC" />
            </div>
            <div className="text-[10px] text-white/45 tracking-wider">After this, price goes back to ${promo.original_price}.</div>
        </div>
    );
};

export default PromoCountdown;
